import { useContext, useMemo, useState } from 'react';
import { MapContext } from '../../contexts/MapContext';
import { getFarmMeta } from '../../utils/meta';
import { useFarmName } from '../../utils/hooks';
import { useHiddenSectionsContext } from '../../contexts/HiddenSectionsContext';
import FarmSummary from './FarmSummary';
import { useUnassignedStemsContext } from '../../contexts/UnassignedStemsContext';
import RightMenuTabs from './RightMenuTabs';
import { PanelMainGroup } from '../SidePanel';
import FarmNotes from './notes/FarmNotes';
import { getFarmCropUsage } from '../../utils/cropUsage';
import { rightMenuTabs } from '../../contexts/RightMenuTabContext';

const NOTES_TAB = 'Notes';

const FieldsPageFarmSummary = ({ fieldSections, readonly, colors }) => {
  const [activeTab, setActiveTab] = useState(rightMenuTabs.INSPECT);

  const {
    crops: { availableCrops: cropMap, cropNameToId, cropVarietyIdToCropId },
    patterns: { inRowPatternsMap },
    mapState: { activeSectionGroup },
  } = useContext(MapContext);

  const farmName = useFarmName();

  const { showHiddenSections } = useHiddenSectionsContext();
  const { includeUnassignedStems } = useUnassignedStemsContext();

  const {
    totals,
    sectionCount,
    hasUnassignedStems,
    cropData,
    hiddenSectionCount,
  } = useMemo(
    () =>
      getFarmMeta({
        fieldSections,
        cropsById: cropMap,
        cropNameToId,
        cropVarietyIdToCropId,
        inRowPatternsMap,
        includeHiddenSections: showHiddenSections,
        includeUnassignedStems,
      }),
    [
      fieldSections,
      cropMap,
      cropNameToId,
      cropVarietyIdToCropId,
      inRowPatternsMap,
      showHiddenSections,
      includeUnassignedStems,
    ],
  );

  const usageData = useMemo(
    () => getFarmCropUsage({ cropNameToId, fieldSections, inRowPatternsMap }),
    [cropNameToId, fieldSections, inRowPatternsMap],
  );

  const sectionsForExport = useMemo(
    () =>
      showHiddenSections
        ? fieldSections
        : fieldSections.filter(({ shown }) => shown),
    [fieldSections, showHiddenSections],
  );

  return (
    <>
      <RightMenuTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={[rightMenuTabs.INSPECT, NOTES_TAB]}
      />
      <PanelMainGroup>
        {activeTab === rightMenuTabs.INSPECT && (
          <FarmSummary
            hiddenSectionCount={hiddenSectionCount}
            totals={totals}
            sectionCount={sectionCount}
            hasUnassignedStems={hasUnassignedStems}
            cropData={cropData}
            usageData={usageData}
            sectionsForExport={sectionsForExport}
            farmName={farmName}
            activeSectionGroup={activeSectionGroup}
            readonly={readonly}
            colors={colors}
          />
        )}
        {activeTab === NOTES_TAB && <FarmNotes />}
      </PanelMainGroup>
    </>
  );
};

export default FieldsPageFarmSummary;
